import PropTypes from "prop-types";
import styles from "./styles.module.css";
import { FormattedMessage } from "react-intl";
import ModalTitle from "./ModalTitle";
const Modal = ({
  type = "",
  open,
  title = "Title",
  subTitle = "",
  description = "",
  okText,
  canelText,
  setOpen,
  onSubmit,
  onCancel,
  isDisabled,
  confirmDisabled,
  children,
  tabs,
  noActions,
  handleClose,
  handleClickOutside,
  bodyStyle,
  deletePrimary,
  actions,
}) => {
  const closeModal = () => {
    if (handleClose) handleClose();
    else if (setOpen) setOpen(false);
  };

  const handleOpenUnsavedModal = (e) => {
    if (handleClickOutside && e.target === e.currentTarget) {
      handleClickOutside();
    }
  };

  const wrapperTypeClass =
    {
      form: styles["form-container"],
      "profile-history": styles["profile-history-container"],
      "email-activity": styles["email-activity-container"],
      "subid-alias-history": styles["subid-alias-history-container"],
    }[type] || "";

  const contentTypeClass =
    {
      form: styles["form-content"],
      "profile-history": styles["profile-history-content"],
      "email-activity": styles["email-activity-content"],
      "subid-alias-history": styles["subid-alias-history-content"],
      "coco-link-generator": styles["coco-link-generator-container"],
    }[type] || "";

  const footerClass =
    type === "coco-link-generator"
      ? styles["coco-link-generator-footer"]
      : styles["no-action-footer"];

  return (
    <div
      className={`${styles["modal-overlay"]} ${
        open ? styles["open"] : styles["hide"]
      }`}
      onClick={handleOpenUnsavedModal}
    >
      {open && (
        <div className={`${styles["modal-wrapper"]} ${wrapperTypeClass}`}>
          <ModalTitle
            title={title}
            subTitle={subTitle}
            tabs={tabs}
            closeModal={closeModal}
            actions={actions}
          />

          <div
            className={`${styles["modal-content"]} ${contentTypeClass} ${
              bodyStyle || ""
            }`}
          >
            {description && (
              <p className={styles["modal-description"]}>{description}</p>
            )}
            {children}
          </div>

          {!noActions ? (
            <div className={styles["modal-footer"]}>
              <button
                type="button"
                disabled={isDisabled}
                onClick={onCancel || closeModal}
                className={isDisabled ? styles["disabled"] : ""}
              >
                {canelText || (
                  <FormattedMessage id="label.cancel" defaultMessage="Cancel" />
                )}
              </button>
              <button
                type="button"
                disabled={isDisabled || confirmDisabled}
                className={`${styles["primary"]} ${
                  isDisabled || confirmDisabled ? styles["disabled"] : ""
                } ${deletePrimary ? styles["delete"] : ""}`}
                onClick={onSubmit}
              >
                {okText || (
                  <FormattedMessage
                    id="label.confirm"
                    defaultMessage="Confirm"
                  />
                )}
              </button>
            </div>
          ) : (
            <div className={footerClass} />
          )}
        </div>
      )}
    </div>
  );
};

Modal.propTypes = {
  type: PropTypes.string,
  open: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.node,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  okText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  canelText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  setOpen: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  isDisabled: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  children: PropTypes.node,
  tabs: PropTypes.bool,
  noActions: PropTypes.bool,
  handleClose: PropTypes.func,
  handleClickOutside: PropTypes.func,
  bodyStyle: PropTypes.string,
  deletePrimary: PropTypes.bool,
  actions: PropTypes.node,
};

export default Modal;
